import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/home/HomeView.vue";
import packageJson from "../../package.json";
import SearchView from "@/views/search/SearchView.vue";
import SpeciesView from "@/views/species/SpeciesView.vue";
import TfView from "@/views/tf/TfView.vue";
import AboutView from "@/views/about/AboutView.vue";
import DetailView from "@/views/details/DetailView.vue";
import CofDetailView from "@/views/details/CofDetailView.vue";

Vue.use(VueRouter);

export const routes = [
  {
    path: "/",
    redirect: "/home",
    nav: false,
  },
  {
    path: "/home",
    name: "Home",
    component: HomeView,
    meta: {
      title: "Home",
    },
    nav: true,
  },
  {
    path: "/search",
    name: "Search",
    component: SearchView,
    meta: {
      title: "Search",
    },
    nav: true,
  },
  {
    path: "/species",
    name: "Species",
    component: SpeciesView,
    meta: {
      title: "Species",
      savePosition: true,
    },
    nav: true,
  },
  {
    path: "/tf-view",
    name: "TF",
    component: TfView,
    meta: {
      title: "TF",
      savePosition: true,
    },
    nav: true,
  },
  /* {
   path: "/tf-cof",
   name: "TF-Cof",
   component: TfCofView,
   meta: {
   title: "TF-Cof",
   savePosition: true,
   },
   nav: true,
   }, */
  {
    path: "/about",
    name: "About",
    component: AboutView,
    meta: {
      title: "About",
    },
    nav: true,
  },
  {
    path: "/detail",
    name: "Detail",
    component: DetailView,
    meta: {
      title: "Detail",
    },
    nav: false,
  },
  {
    path: "/cofDetail",
    name: "CofDetail",
    component: CofDetailView,
    meta: {
      title: "Detail",
    },
    nav: false,
  },
];

const scrollBehavior = function scrollBehavior(to, from, savedPosition) {
  if (to.meta.savePosition || savedPosition) {
    return savedPosition;
  } else {
    return { x: 0, y: 0 };
  }
};
const router = new VueRouter({
  routes,
  scrollBehavior,
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title + " - " + packageJson.title;
  next();
});

export default router;
